import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = ["aria-pressed", "title", "data-testid", "onClick"]
const _hoisted_3 = { class: "font-mono tabular-nums" }
const _hoisted_4 = ["aria-pressed", "data-testid"]
const _hoisted_5 = { class: "font-mono tabular-nums" }

import type { PrioritySlaState } from '@/Network/Types/Responses/PriorityPaymentsResponses'

import { PRIORITY_SLA_STATES } from '../filters'
import { PRIORITY_SLA_STATE_LABELS } from '../slaFormat'
import PrioritySlaStateBadge from './PrioritySlaStateBadge.vue'

/**
 * Atalhos de estado do M3 (Q8/Q22). Os números vêm de `slaCounters.byState`
 * (respeitam aba e `slaBand`, ignoram o próprio filtro). Clicar SUBSTITUI o
 * filtro de estado por aquele único estado; clicar de novo limpa. A
 * multi-seleção fica no seletor "Estado do SLA" da barra.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'PriorityPaymentsCounters',
  props: {
    byState: {},
    overdueCarryOver: {},
    activeStates: {},
    isOverdueOnly: { type: Boolean },
    testId: { default: 'priority-payments-counters' }
  },
  emits: ["select-states", "select-overdue"],
  setup(__props: any, { emit }) {

const props = __props;





const isActive = (state: PrioritySlaState): boolean =>
  props.activeStates.length === 1 && props.activeStates[0] === state

function onSelect(state: PrioritySlaState): void {
  emit('select-states', isActive(state) ? [] : [state])
}

return (_ctx: any,_cache: any) => {
  return (_ctx.byState)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "flex flex-wrap items-center gap-1.5",
        role: "group",
        "aria-label": "Atalhos de estado do SLA",
        "data-testid": _ctx.testId
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PRIORITY_SLA_STATES), (state) => {
          return (_openBlock(), _createElementBlock("button", {
            key: state,
            type: "button",
            class: "rounded-full",
            "aria-pressed": isActive(state),
            title: state === 'OVERDUE' ? 'Estourado: prazo vencido' : undefined,
            "data-testid": `${_ctx.testId}-card-${state}`,
            onClick: ($event: any) => (onSelect(state))
          }, [
            _createVNode(PrioritySlaStateBadge, {
              state: state,
              class: _normalizeClass(isActive(state) ? 'ring-2 ring-primary ring-offset-1' : ''),
              "test-id": `${_ctx.testId}-badge-${state}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(PRIORITY_SLA_STATE_LABELS)[state]) + " ", 1),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.byState[state] ?? 0), 1)
              ]),
              _: 2
            }, 1032, ["state", "class", "test-id"])
          ], 8, _hoisted_2))
        }), 128)),
        (_ctx.overdueCarryOver !== null)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: _normalizeClass(["inline-flex items-center gap-1 rounded-full border border-red-700 px-2 py-0.5 text-xs font-semibold text-red-700", _ctx.isOverdueOnly ? 'bg-red-50 ring-2 ring-primary ring-offset-1' : 'bg-white']),
              "aria-pressed": _ctx.isOverdueOnly,
              title: "Atrasados: À vista de ciclos anteriores (7 dias)",
              "data-testid": `${_ctx.testId}-card-carry-over`,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('select-overdue')))
            }, [
              _createTextVNode(" Atrasados "),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.overdueCarryOver), 1)
            ], 10, _hoisted_4))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})